<template>
  <div class="contacts_block">
    <router-link class="response-vacancy-title" :to="{ path: `/vacancies/${vacancy.id}` }">
      {{ vacancy.name }}
    </router-link>

    <div class="info_block">
      <span v-if="!vacancy.is_active && !vacancy.is_deleted" class="archive-label">
        {{ $tr('vacancies.archiveLabel') }}
      </span>

      <span v-if="vacancy.is_deleted" class="remove-label">
        {{ $tr('vacancies.removeLabel') }}
      </span>

      <a class="email_color" :href="'mailto:' + candidate.email">{{ candidate.email }}</a>

      <span>{{ candidate.phone }}</span>

      <template v-if="isInternalCandidate">
        <i>|</i>
        <span v-tooltip="$tr('responses.internalCandidate')" class="icon icon-profile internal-candidate"></span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessResponseBlocksBlockContacts',

  props: {
    candidate: {
      type: Object,
      default: () => {}
    },

    vacancy: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    store() {
      return this.$store.state.process.citibank.response.single.data;
    },

    responseSpecialProcess() {
      return this.store ? this.store.special_process : null;
    },

    isInternalCandidate() {
      return this.responseSpecialProcess ? this.responseSpecialProcess.is_internal : null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/components/response/blocks/BlockContacts.scss';

.internal-candidate {
  font-size: 18px;

  &:hover {
    color: #3eaf29;
  }
}
</style>
